const stripeStyles = {
    base: {
        fontSize: "24px",
        lineHeight: "36px",
        height: "40px",
        color: "#000000",
        iconColor: "#111111",
        letterSpacing: "0.025em",
        fontFamily: "BWHaasGrotesk-55Roman-Web, Helvetica Neue, Helvetica, Arial, sans-serif",
        "::placeholder": {
            color: "#787878"
        }
    },
    invalid: {
        color: "#FF433D",
        "::placeholder": {
            color: "#FF433D"
        }
    }
};

export default stripeStyles;
